<main>
  <dxo-card>
    <card-body>
      <div class="placeholder-card">
        <dxo-circular-loader size="medium"></dxo-circular-loader>
        <h2 class="spinner-text bold">Logging you in...</h2>
        <div class="logo"><img class="logo" src="/assets/images/symetra_logo.svg" alt="symetra logo" /></div>
      </div>
    </card-body>
  </dxo-card>
</main>
